import React from "react";
import { Link } from "react-router-dom";
import { Phone, EnvelopeSimple, MapPin, Clock } from "@phosphor-icons/react";

export default function Footer({ business, onBook }) {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-zinc-950 text-zinc-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="h-9 w-9 rounded-lg bg-blue-600 grid place-items-center text-white font-heading font-extrabold">TC</span>
              <span className="font-heading text-xl font-extrabold text-white">{business?.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed max-w-sm">
              Trusted IT care for homes and businesses. PC tune-ups, malware removal, data backup, and everything in between.
            </p>
          </div>

          <div>
            <div className="text-white font-semibold mb-4">Services</div>
            <ul className="space-y-2 text-sm">
              {[
                { label: "PC Tune-Up & Repair", href: "/computer-repair" },
                { label: "Virus & Malware Removal", href: "/virus-removal" },
                { label: "Ransomware Removal & Recovery", href: "/ransomware-removal" },
                { label: "Data Recovery", href: "/data-recovery" },
                { label: "Laptop Repair", href: "/laptop-repair" },
                { label: "Remote IT Support", href: "/remote-it-support" },
                { label: "Wi-Fi Optimization", href: "/wifi-optimization" },
                { label: "TV Mounting", href: "/tv-mounting" },
                { label: "Security Cameras", href: "/security-cameras" },
                { label: "Smart Home Setup", href: "/smart-home-setup" },
                { label: "Managed IT (Business)", href: "/managed-it-services" },
                { label: "Cybersecurity", href: "/cybersecurity" },
                { label: "Backup & Disaster Recovery", href: "/business-backup-disaster-recovery" },
                { label: "On-Site IT Support", href: "/onsite-it-support" },
              ].map((s) => (
                <li key={s.label}>
                  <Link to={s.href} className="hover:text-white transition-colors" data-testid={`footer-service-${s.href.replace(/\//g, "")}`}>
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-white font-semibold mb-4">Contact</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2">
                <Phone size={16} weight="duotone" className="text-blue-500" />
                <a href={`tel:${business?.phoneTel || "+19197375442"}`} className="hover:text-white">{business?.phone}</a>
              </li>
              <li className="flex items-center gap-2">
                <EnvelopeSimple size={16} weight="duotone" className="text-blue-500" />
                <a href={`mailto:${business?.email}`} className="hover:text-white">{business?.email}</a>
              </li>
              <li className="flex items-center gap-2">
                <Clock size={16} weight="duotone" className="text-blue-500" />
                Mon–Sat, 8am–8pm
              </li>
            </ul>

            <div className="mt-6 space-y-4 text-sm" data-testid="footer-offices">
              <div>
                <div className="text-white font-semibold mb-1">TechConnect LLC – Clayton</div>
                <address className="not-italic leading-relaxed text-zinc-400">
                  <span className="flex items-start gap-2">
                    <MapPin size={14} weight="duotone" className="text-blue-500 mt-0.5 shrink-0" />
                    <span>5720 US 70 Bus Hwy, Suite B<br />Clayton, NC 27520</span>
                  </span>
                  <span className="flex items-center gap-2 mt-1">
                    <Phone size={14} weight="duotone" className="text-blue-500" />
                    <a href="tel:+19197375442" className="hover:text-white">(919) 737-5442</a>
                  </span>
                </address>
              </div>
              <div>
                <div className="text-white font-semibold mb-1">TechConnect LLC – Granite Falls</div>
                <address className="not-italic leading-relaxed text-zinc-400">
                  <span className="flex items-start gap-2">
                    <MapPin size={14} weight="duotone" className="text-blue-500 mt-0.5 shrink-0" />
                    <span>10A Falls Avenue<br />Granite Falls, NC 28630</span>
                  </span>
                  <span className="flex items-center gap-2 mt-1">
                    <Phone size={14} weight="duotone" className="text-blue-500" />
                    <a href="tel:+19197375442" className="hover:text-white">(919) 737-5442</a>
                  </span>
                </address>
              </div>
              <div className="text-zinc-400">Remote support available nationwide.</div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs">
          <div>© {year} {business?.name}. All rights reserved.</div>
          <div className="flex items-center gap-5">
            <button onClick={() => onBook && onBook()} className="hover:text-white" data-testid="footer-book-btn">Book appointment</button>
            <a href="#contact" className="hover:text-white">Contact</a>
            <a href="#pricing" className="hover:text-white">Pricing</a>
            <a
              href="https://blog.techconnectncllc.services"
              target="_blank"
              rel="noopener"
              className="hover:text-white"
              data-testid="footer-guides"
            >
              Guides
            </a>
            <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
